import api from './api';

const accountService = {
  // Get all accounts (hotel chains) with optional filters
  // Note: For regular users, this should be filtered by user-account relationships
  // Super admins can see all accounts
  // TODO: Add userId filter for non-super-admin users once user-account relationship is implemented
  getAllAccounts: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.parentAccountId) params.append('parentAccountId', filters.parentAccountId);
    if (filters.accountType) params.append('accountType', filters.accountType);
    if (filters.activeOnly) params.append('activeOnly', filters.activeOnly);
    if (filters.demoOnly) params.append('demoOnly', filters.demoOnly);
    if (filters.partnerid) params.append('partnerid', filters.partnerid);
    if (filters.limit) params.append('limit', filters.limit);
    // TODO: Add userId parameter here for filtering by user-account relationship

    const response = await api.get(`/accounts${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  // Get a single account by ID
  getAccountById: async (id) => {
    const response = await api.get(`/accounts/${id}`);
    return response.data;
  },

  // Create a new account
  createAccount: async (accountData) => {
    const response = await api.post('/accounts', accountData);
    return response.data;
  },

  // Update an account (PUT - full update)
  updateAccount: async (id, accountData) => {
    const response = await api.put(`/accounts/${id}`, accountData);
    return response.data;
  },

  // Patch an account (PATCH - partial update)
  // Sync scheduling (V596): the chain's projects and cutover bookings, and what the caller may do with them.
  getSchedule: async (accountId) => {
    const response = await api.get(`/accounts/${accountId}/schedule`);
    return response.data;
  },
  // The order form: { syncProjectId, proposedDate, hotelCode, country, currency, contactName, contactEmail,
  // contactPhone, contactRole, notes } — names as schedule.js reads them.
  proposeSchedule: async (accountId, form) => {
    const response = await api.post(`/accounts/${accountId}/schedule`, form);
    return response.data;
  },
  // Who is told of booking changes (V598): { emails: [{ id, email, source }], teamsWebhook }. The three writes are the
  // shared NotificationsPanel's `persistence` contract, as on sync projects.
  getScheduleNotifications: async (accountId) => {
    const response = await api.get(`/accounts/${accountId}/schedule/notifications`);
    return response.data;
  },
  addScheduleNotificationEmail: async (accountId, { email, source }) => {
    const response = await api.post(`/accounts/${accountId}/schedule/notifications`, { email, source });
    return response.data;
  },
  removeScheduleNotificationEmail: async (accountId, emailId) => {
    const response = await api.delete(`/accounts/${accountId}/schedule/notifications?emailId=${emailId}`);
    return response.data;
  },
  saveScheduleNotificationWebhook: async (accountId, teamsWebhook) => {
    const response = await api.put(`/accounts/${accountId}/schedule/notifications`, { teamsWebhook });
    return response.data;
  },
  // { action: 'update' | 'commit' | 'decline' | 'cancel', proposedDate?, committedDate?, reason?, …order form }
  actOnSchedule: async (accountId, requestId, body) => {
    const response = await api.put(`/accounts/${accountId}/schedule/${requestId}`, body);
    return response.data;
  },

  patchAccount: async (id, accountData) => {
    const response = await api.patch(`/accounts/${id}`, accountData);
    return response.data;
  },

  // Delete an account
  deleteAccount: async (id) => {
    const response = await api.delete(`/accounts/${id}`);
    return response.data;
  },

  // SyncConnect client build settings for the chain. These are baked into every SyncConnect client
  // generated for a sync project under this account, so the installer asks the on-site user nothing.
  getSyncConnectSettings: async (id, reveal = false) => {
    const response = await api.get(`/accounts/${id}/sync-connect-settings${reveal ? '?reveal=true' : ''}`);
    return response.data;
  },

  updateSyncConnectSettings: async (id, settings) => {
    const response = await api.put(`/accounts/${id}/sync-connect-settings`, settings);
    return response.data;
  }
};

export default accountService;
